<ng-container>
  @if (roles$ | async; as roles) {
    <div class="pt-2">
      @for (role of roles; track role) {
        <div class="form-check">
          @if (!disabled) {
            <input
              [attr.data-cy]="'checkbox-role-' + role.id"
              class="form-check-input"
              type="checkbox"
              [id]="role.id"
              [name]="role.id"
              [checked]="isSelected(role)"
              (change)="toggle(role)" />
          }
          <label
            class="form-check-label"
            [for]="role.id"
            [attr.data-cy-value]="role.name">
            <span [class.disabled]="disabled && !isSelected(role)">{{
              role.name | titlecase
            }}</span>
            &nbsp;<i
              class="text-primary fa fa-info-circle"
              [title]="role.description"></i>
          </label>
        </div>
      }
    </div>
  }
</ng-container>
